import React from 'react'
import { func, object } from 'prop-types'

import { Grid, Row, Col } from 'react-bootstrap'

import InputBlock from 'coact/InputBlock'


function HeadEditor (props) {
  const { spliter, style } = props
  const getChildProps = spliter(props)

  return (
    <div className={style['form-head']}>
      <Grid>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('key')} disabled="true" />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('type')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('lockPrice')} />
          </Col>
        </Row>
        <Row>
          <Col md={8}>
            <InputBlock {...getChildProps('name')} disabled="true" />
          </Col>
        </Row>
        <br />
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('brandRef')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('brandCode')} disabled="true" />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('supplierRef')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('orderCode')} />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('origin')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('unit')} />
          </Col>
        </Row>
        <br />
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('centerCost')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('price')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('staffPrice')} />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('storeCost')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('salePrice')} />
          </Col>
        </Row>
        <br />
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('model')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('material')} />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('size')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('contour')} />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('colorCode')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('rimType')} />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('templeLength')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('colorRef')} />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('isContract')} />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('orderFrom')} />
          </Col>
        </Row>
        <br />
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('payType')} />
          </Col>
        </Row>
        <br />
        <Row>
          <Col md={8}>
            <InputBlock {...getChildProps('note')} />
          </Col>
        </Row>
        <br />
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('ragicStoreNodeId')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('ragicCenterNodeId')} />
          </Col>
        </Row>
      </Grid>
    </div>
  )
}

HeadEditor.propTypes = {
  spliter: func.isRequired,
  style: object.isRequired,
}

export default HeadEditor



// WEBPACK FOOTER //
// ./src/components/products/productsA/HeadEditor/HeadEditor.jsx